import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { validateCognitoConfig } from '@brent/shared'

const userPoolId = import.meta.env.VITE_ADMIN_COGNITO_USER_POOL_ID
const clientId = import.meta.env.VITE_ADMIN_COGNITO_CLIENT_ID
const region = import.meta.env.VITE_ADMIN_COGNITO_REGION || 'eu-west-1'
const domain = import.meta.env.VITE_ADMIN_COGNITO_DOMAIN

// Validate configuration
export const cognitoConfig = validateCognitoConfig({
  userPoolId,
  clientId,
  region,
  domain,
})

// Create user pool instance
export const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.userPoolId,
  ClientId: cognitoConfig.clientId,
})

// Export other config values
export const cognitoDomain = cognitoConfig.domain
export const cognitoClientId = cognitoConfig.clientId
